// @flow
import { ModuleInfotoolsActionTypes } from './constants';

const INIT_STATE = {
    moduleInfotools: {},
    listaModulesInfotools: [],
    loading: false,
    error: false,
    formSubmited: false
};

type ModuleInfotoolsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { moduleInfotools?: {} | null, listaModulesInfotools?: [] | null, loading?: boolean, +value ?: boolean };

const ModuleInfotools = (state: State = INIT_STATE, action: ModuleInfotoolsAction): any => {
    // console.log(action);
    switch (action.type) {
        case ModuleInfotoolsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case ModuleInfotoolsActionTypes.GET_MODULE_INFOTOOLS: {
                    return {
                        ...state,
                        moduleInfotools: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case ModuleInfotoolsActionTypes.LIST_MODULES_INFOTOOLS: {
                    return {
                        ...state,
                        listaModulesInfotools: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                // case ModuleInfotoolsActionTypes.ADD_MODULE_INFOTOOLS: {
                //     return {
                //         ...state,
                //         error: false,
                //         loading: false,
                //         formSubmited: true
                //     };
                // }
                // case ModuleInfotoolsActionTypes.UPDATE_MODULE_INFOTOOLS: {
                //     return {
                //         ...state,
                //         error: false,
                //         loading: false,
                //         formSubmited: true
                //     };
                // }
                // case ModuleInfotoolsActionTypes.DELETE_MODULE_INFOTOOLS: {
                //     return {
                //         ...state,
                //         error: false,
                //         loading: false,
                //         formSubmited: true
                //     };
                // }
                default:
                    return { ...state };
            }

        case ModuleInfotoolsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case ModuleInfotoolsActionTypes.GET_MODULE_INFOTOOLS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        moduleInfotools: {},
                        loading: false,
                    };
                }
                case ModuleInfotoolsActionTypes.LIST_MODULES_INFOTOOLS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaModulesInfotools: [],
                        loading: false,
                    };
                }
                // case ModuleInfotoolsActionTypes.ADD_MODULE_INFOTOOLS: {
                //     return {
                //         ...state,
                //         error: action.payload.error,
                //         loading: false,
                //         formSubmited: true
                //     };
                // }
                // case ModuleInfotoolsActionTypes.UPDATE_MODULE_INFOTOOLS: {
                //     return {
                //         ...state,
                //         error: action.payload.error,
                //         loading: false,
                //         formSubmited: true
                //     };
                // }
                // case ModuleInfotoolsActionTypes.DELETE_MODULE_INFOTOOLS: {
                //     return {
                //         ...state,
                //         error: action.payload.error,
                //         loading: false,
                //         formSubmited: true
                //     };
                // }
                default:
                    return { ...state };
            }

        case ModuleInfotoolsActionTypes.GET_MODULE_INFOTOOLS:
            return { ...state, error: false, loading: true };
        case ModuleInfotoolsActionTypes.LIST_MODULES_INFOTOOLS:
            return { ...state, error: false, loading: true };
        // case ModuleInfotoolsActionTypes.ADD_MODULE_INFOTOOLS:
        //     return { ...state, error: false, loading: true };
        // case ModuleInfotoolsActionTypes.UPDATE_MODULE_INFOTOOLS:
        //     return { ...state, error: false, loading: true };
        // case ModuleInfotoolsActionTypes.DELETE_MODULE_INFOTOOLS:
        //     return { ...state, error: false, loading: true };
        case ModuleInfotoolsActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                moduleInfotools: {},
                listaModulesInfotools: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default ModuleInfotools;
